"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemerWrapper = void 0;
const solana_contrib_1 = require("@saberhq/solana-contrib");
const token_utils_1 = require("@saberhq/token-utils");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const pda_1 = require("./pda");
class RedeemerWrapper {
    constructor(sdk, redeemer, iouMint, redemptionMint, data) {
        this.sdk = sdk;
        this.program = sdk.programs.Redeemer;
        this.iouMintKey = iouMint;
        this.redemptionMintKey = redemptionMint;
        this.key = redeemer;
        this.data = data;
    }
    static load(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { iouMint, redemptionMint, sdk } = args;
            const [redeemer] = yield (0, pda_1.findRedeemerKey)({ iouMint, redemptionMint });
            const program = sdk.programs.Redeemer;
            const data = yield program.account.redeemer.fetch(redeemer);
            return new RedeemerWrapper(sdk, redeemer, iouMint, redemptionMint, data);
        });
    }
    static createRedeemer(ctorArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            const { iouMint, redemptionMint, sdk } = ctorArgs;
            const { provider } = sdk;
            const [redeemer, bump] = yield (0, pda_1.findRedeemerKey)({ iouMint, redemptionMint });
            const instructions = [];
            const { address, instruction } = yield (0, token_utils_1.getOrCreateATA)({
                provider,
                mint: redemptionMint,
                owner: redeemer,
            });
            if (instruction) {
                instructions.push(instruction);
            }
            instructions.push(sdk.programs.Redeemer.instruction.createRedeemer(bump, {
                accounts: {
                    redeemer,
                    tokens: {
                        iouMint,
                        redemptionMint,
                        redemptionVault: address,
                    },
                    payer: provider.wallet.publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                },
            }));
            return {
                bump,
                ctorArgs,
                tx: new solana_contrib_1.TransactionEnvelope(sdk.provider, instructions),
            };
        });
    }
    /**
     * redeemTokensIx
     */
    redeemTokensIx(args) {
        return this.program.instruction.redeemTokens(args.tokenAmount, {
            accounts: this.getRedeemTokenAccounts(args),
        });
    }
    /**
     * redeemTokensFromMintProxyIx
     */
    redeemTokensFromMintProxyIx(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { account, state } = this.sdk.programs.MintProxy;
            const mintProxyData = yield state.fetch();
            return this.program.instruction.redeemTokensFromMintProxy(args.tokenAmount, {
                accounts: {
                    redeemCtx: this.getRedeemTokenAccounts(args),
                    proxyMintAuthority: mintProxyData.proxyMintAuthority,
                    minterInfo: yield account.minterInfo.associatedAddress(this.key),
                    mintProxyState: state.address(),
                    mintProxyProgram: constants_1.ADDRESSES.MintProxy,
                },
            });
        });
    }
    /**
     * redeemAllTokensFromMintProxyIx
     */
    redeemAllTokensFromMintProxyIx(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { account, state } = this.sdk.programs.MintProxy;
            const mintProxyData = yield state.fetch();
            return this.program.instruction.redeemAllTokensFromMintProxy({
                accounts: {
                    redeemCtx: this.getRedeemTokenAccounts(args),
                    proxyMintAuthority: mintProxyData.proxyMintAuthority,
                    minterInfo: yield account.minterInfo.associatedAddress(this.key),
                    mintProxyState: state.address(),
                    mintProxyProgram: constants_1.ADDRESSES.MintProxy,
                },
            });
        });
    }
    /**
     * redeemTokensFromMintProxy
     */
    redeemTokensFromMintProxy({ amount, sourceAuthority = this.sdk.provider.wallet.publicKey, } = {
        sourceAuthority: this.sdk.provider.wallet.publicKey,
    }) {
        return __awaiter(this, void 0, void 0, function* () {
            const atas = yield (0, token_utils_1.getOrCreateATAs)({
                provider: this.sdk.provider,
                mints: {
                    iou: this.data.iouMint,
                    redemption: this.data.redemptionMint,
                },
                owner: sourceAuthority,
            });
            const commonArgs = {
                sourceAuthority,
                iouSource: atas.accounts.iou,
                redemptionDestination: atas.accounts.redemption,
            };
            const redeemIX = amount
                ? yield this.redeemTokensFromMintProxyIx(Object.assign(Object.assign({}, commonArgs), { tokenAmount: amount }))
                : yield this.redeemAllTokensFromMintProxyIx(commonArgs);
            return new solana_contrib_1.TransactionEnvelope(this.sdk.provider, [
                ...atas.instructions,
                redeemIX,
            ]);
        });
    }
    getRedeemTokenAccounts(args) {
        const { iouSource, redemptionDestination, sourceAuthority } = args;
        return {
            redeemer: this.key,
            tokens: {
                iouMint: this.data.iouMint,
                redemptionMint: this.data.redemptionMint,
                redemptionVault: this.data.redemptionVault,
                tokenProgram: token_utils_1.TOKEN_PROGRAM_ID,
            },
            sourceAuthority,
            iouSource,
            redemptionDestination,
        };
    }
}
exports.RedeemerWrapper = RedeemerWrapper;
//# sourceMappingURL=wrapper.js.map